import { create } from "zustand";
import { IApiError } from "@/lib/types";
import { devtools } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

// ---------------------- Variables

const enableStore = import.meta.env.VITE_CURRENT_MODE !== "production";

// ---------------------- Interfaces

interface ErrorState {
  // --------- State

  error: IApiError | null;

  // --------- Actions

  setError: (error: IApiError | null) => void;
}

// ---------------------- Store

export const useErrorStore = create<ErrorState>()(
  devtools(
    immer((set) => ({
      // --------- State

      error: null,

      // --------- Actions

      setError: (error: IApiError | null) =>
        set(
          (state) => {
            state.error = error;
          },
          false,
          "error/setError",
        ),
    })),
    {
      name: "ErrorStore",
      enabled: enableStore,
      store: "ErrorStore",
    },
  ),
);
